module.exports = __webpack_public_path__ + "img/mapIcon.5b11fa5d.svg";